import { interpolateCoords } from './Interpolate'

const toEraserTypes = ['brush', 'line', 'square', 'circle']

const createEmptyHashTree = coords => {
    const res = {}

    coords.forEach(c => {
        for (let i = c[0]-3; i <= +c[0]+3; i++) {
            const iStr = String(i)
            if (!res[iStr]) res[iStr] = new Set()
            for (let k = c[1]-3; k <= +c[1]+3; k++) {
                res[iStr].add(String(k))
            }
        }
    })

    return res
}

const applyFilterToAllMarks = (allMarks, empty) => {
    if (!allMarks || !empty) return

    const emptyHashTree = createEmptyHashTree(empty)

    const res = []
    for (let i = 0; i < allMarks.length; i++) {
        let newCoords = [];
        if (allMarks[i].type === 'point') {
            const checkCoords = filterFilledCoords([[parseInt(allMarks[i].x), parseInt(allMarks[i].y)]], emptyHashTree)
            if (checkCoords.length > 0) {
                res.push({
                    ...allMarks[i], temp_id: Date.now() + 1
                })
            }
        }
        if (toEraserTypes.indexOf(allMarks[i].type) > -1) {
            newCoords = filterFilledCoords(allMarks[i].coords, emptyHashTree)
            const collection = createNewCoordsCollection(allMarks[i].coords, newCoords)
            if (!collection) return
            for (let j = 0; j < collection.length; j++) {

                res.push({
                    ...allMarks[i], coords: collection[j], temp_id: Date.now() + i
                })
            }
        }
    }
    return res;
}

const clearDuplicates = (arr) => {
    if (!arr) return
    let set = new Set(arr.map(JSON.stringify));
    return Array.from(set).map(JSON.parse);
}

const addSideCoords = interpolated => {
    if (!interpolated) return
    const empty = []

    for (let i = 0; i < interpolated.length; i++) {
        const first = parseInt(interpolated[i][0])
        const second = parseInt(interpolated[i][1])

        empty.push(interpolated[i])

        for (let j = 1; j < 6; j++) {
            empty.push([first + j, second])
        }
        for (let j = 1; j < 6; j++) {
            empty.push([first - j, second])
        }
        for (let j = 1; j < 6; j++) {
            empty.push([first, second + j])
        }
        for (let j = 1; j < 6; j++) {
            empty.push([first, second - j])
        }
    }

    return empty
}

const filterFilledCoords = (filled, emptyHashTree) =>
  !filled || !emptyHashTree
    ? undefined
    : filled.filter(f => !(emptyHashTree[String(f[0])] && emptyHashTree[String(f[0])].has(String(f[1]))))

const createNewCoordsCollection = (filled, filteredArr) => {
    if (!filled || !filteredArr) return
    const coordsCollection = []
    let tmpCollection = []
    if (!filled && !filteredArr) return
    for (let i = 0; i < filteredArr.length; i++) {
        let currentOldIndex = filled.indexOf(filteredArr[i])
        let nextOldIndex = filled.indexOf(filteredArr[i + 1])
        tmpCollection.push(filteredArr[i])
        if (Math.abs(currentOldIndex - nextOldIndex) > 1) {
            tmpCollection.length > 1 && coordsCollection.push(tmpCollection)
            tmpCollection = []
        }
    }
    return coordsCollection
}

const removeEmptyObjects = arr => {
    if (!arr) return
    return arr.filter(obj => {
        if (obj.type === 'brush') return obj.coords.length > 1
        else return true
    })
}

export const eraserCalculation = (filledCoords, erasedCoords) => {
    if (!filledCoords || !erasedCoords) return []
    const interpolated = interpolateCoords(clearDuplicates(erasedCoords))
    const empty = clearDuplicates(addSideCoords(interpolated))
    const res = removeEmptyObjects(applyFilterToAllMarks(filledCoords, empty))

    return res
}

